import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import StyledSelect from "../../core/components/fields/styledSelect";
import {loc} from "../../core/common/config/locales";
import ProjectMaterials from "../domain/project/projectMaterialsDomain";

@observer
class ProjectMaterialsForm extends React.Component<FormProps<ProjectMaterials, ProjectMaterials>> {
  render() {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectMaterialsFormDefinition.formName);
    let {
      density, primaryEnergy, thermalCoefficient,
      co2Equivalent, so2Equivalent, po4Equivalent, r11Equivalent, c2h4Equivalent,
      name, code, epdcertification, woodBased,source
    } = fields;
  console.log('MATERIALS FIELDS', fields)

    return (
      <div>
        <div className="row">
          <div className="fx col-xs-3 col-sm-3">
            <MdCheckbox {...woodBased.props} disabled={false} label={loc.i18n`Wood based material`}/>
          </div>

          <div className="fx col-xs-3 col-sm-3">
            <StyledSelect {...epdcertification.props} disabled={woodBased.props.checked}/>
            <Validate field={epdcertification} value={epdcertification.props.value}/>
          </div>
          <div className="fx col-xs-12 col-sm-12">
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-1 col-sm-1">
            <MdTextField {...code.props}/>
            <Validate field={code} value={code.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...density.props}/>
            <Validate field={density} value={density.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...primaryEnergy.props}/>
            <Validate field={primaryEnergy} value={primaryEnergy.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...thermalCoefficient.props}/>
            <Validate field={thermalCoefficient} value={thermalCoefficient.props.value}/>
          </div>
        </div>
        <div className="row">
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...co2Equivalent.props}/>
            <Validate field={co2Equivalent} value={co2Equivalent.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...so2Equivalent.props}/>
            <Validate field={so2Equivalent} value={so2Equivalent.props.value}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...po4Equivalent.props}/>
            <Validate field={po4Equivalent} value={po4Equivalent.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...r11Equivalent.props}/>
            <Validate field={r11Equivalent} value={r11Equivalent.props.value}/>
          </div>
          <div className="fx col-xs-3 col-sm-3">
            <MdTextField {...c2h4Equivalent.props}/>
            <Validate field={c2h4Equivalent} value={c2h4Equivalent.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}
export const ProjectMaterialsFormDefinition: DefinitionType = {
  formName: 'ProjectMaterialsForm',
  fields: [
    {name: 'code', validators: ['IsRequired']},
    {name: 'name',validators: ['IsRequired']},
    {name: 'density',validators: ['IsRequired', 'IsNumber']},
    {name: 'primaryEnergy',validators: ['IsRequired', 'IsNumber']},
    {name: 'co2Equivalent',validators: ['IsRequired', 'IsNumber']},
    {name: 'so2Equivalent',validators: ['IsRequired', 'IsNumber']},
    {name: 'po4Equivalent',validators: ['IsRequired', 'IsNumber']},
    {name: 'r11Equivalent',validators: ['IsRequired', 'IsNumber']},
    {name: 'c2h4Equivalent',validators: ['IsRequired', 'IsNumber']},
    {name: 'woodBased'},
    {name: 'thermalCoefficient',validators: ['IsRequired', 'IsNumber', {validation: 'Min', parameters: {min: 0}}]},
    {name: 'epdcertification',validators: ['IsRequired']},
    {name: 'source'},
  ]
};

export default createForm(ProjectMaterialsFormDefinition, null)(ProjectMaterialsForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectMaterialsForm.tsx